import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withTranslate } from 'react-redux-multilingual'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Snackbar from '@material-ui/core/Snackbar'
import LinkIcon from '@material-ui/icons/Link'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import MailIcon from '@material-ui/icons/Mail'
import { isMobileOrTablet } from '../../helpers/device'
import { getWhatsappLink, getEmailLink } from '../../helpers/share'

class ShareLinks extends React.Component {
  state = { open: false }

  copyToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
      return
    }
    // Fallback para contextos sem Clipboard API (ex.: http em dispositivos
    // antigos). Cria um textarea oculto e usa o comando legado.
    const textField = document.createElement('textarea')
    textField.innerText = text
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
  }

  handleCopyLink = () => {
    this.copyToClipboard(this.props.url)
    this.setState({ open: true })
  }

  handleShareWhatsapp = () => {
    const { url, propertyName, translate } = this.props
    const title = `${propertyName} - ${translate('shareCheckinOnlineMsg')}`
    window.location.href = getWhatsappLink(url, title, isMobileOrTablet())
  }

  handleShareEmail = () => {
    const { url, propertyName, translate } = this.props
    const subject = `${propertyName} - Check in Online`
    const body = `${translate('shareCheckinOnlineMsg')} ${url}`
    window.location.href = getEmailLink(subject, body)
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { classes, translate } = this.props
    const { open } = this.state

    return (
      <>
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <Tooltip title={translate('shareLinkLabel')}>
            <IconButton color="primary" className={classes.button} component="span" size="medium" onClick={this.handleCopyLink}>
              <LinkIcon className={classes.largeIcon} />
            </IconButton>
          </Tooltip>

          <Tooltip title={translate('shareLinkWhatsappLabel')}>
            <IconButton color="primary" className={classes.button} component="span" size="medium" onClick={this.handleShareWhatsapp}>
              <WhatsAppIcon className={classes.largeIcon} />
            </IconButton>
          </Tooltip>

          <Tooltip title={translate('shareLinkEmailLabel')}>
            <IconButton color="primary" className={classes.button} component="span" size="medium" onClick={this.handleShareEmail}>
              <MailIcon className={classes.largeIcon} />
            </IconButton>
          </Tooltip>
        </Grid>
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={open}
          onClose={this.handleClose}
          ContentProps={{ 'aria-describedby': 'message-id' }}
          message={<span id="message-id">{translate('linkSharedLabel')}</span>}
        />
      </>
    )
  }
}

const styles = () => ({
  largeIcon: {
    width: 35,
    height: 35
  }
})

export default withStyles(styles)(withTranslate(ShareLinks))
